// Resolving a nav entry to the page the current user can actually open.
//
// Most entries map 1:1 to a page id. Some fold several pages into one menu
// item as tabs (suggestions renders as a tab inside /products) — those declare
// the folded pages in `NavItem.alt`. Checking only the primary id would hide
// the whole entry from roles that hold just the folded-in page, so we walk the
// candidates and show the entry when any one of them is reachable.
//
// The link always opens the host page (`item.to`): its tab bar already hides
// the tabs the user may not open. Linking a folded page's own route instead
// skips that tab bar — kiểm thử toàn vai 16/09/2026 (H3): sale/CSKH landed on
// the bare /suggestions page and never saw the "Gợi ý cho khách" tab that was
// folded into /products later (a9c3398f6).

import type { Staff } from "@/lib/authv2/store";
import { hasAccess } from "@/lib/auth/page-access";
import { passesContentGate } from "./nav-content-gates";
import type { NavItem } from "./nav-items";

/** The nav item to render for `staff`, or null when no candidate is allowed. */
export function resolveNavItem(item: NavItem, staff: Staff): NavItem | null {
  const candidates = [item.id, ...(item.alt ?? []).map((a) => a.id)];
  const allowed = candidates.some((id) => hasAccess(staff, id) && passesContentGate(id, staff));
  return allowed ? item : null;
}
